import AuthGuard from "@/guards/AuthGuard";
import useAuth from "@/hooks/useAuth";
import { css } from "@emotion/react";
import { useAtomValue, useSetAtom } from "jotai";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { segmentEventPayload, showLoginPopupAtom } from "src/modules/editor-v2/Atoms";
import { EventTrackName } from "src/modules/segment-event-tracking/constant";
import { TrackWebappEvent } from "src/modules/segment-event-tracking/segmentEventTracking";
import FeaturedTemplates from "./FeaturedTemplates";
import Footer from "./Footer";
import Header from "./Header";
import Jumbotron from "./Jumbotron";
import MainSection from "./MainSection";
import CustomMarketplaces from "./CustomMarketplaces";
import SocialMedia from "./SocialMedia";
import Tools from "./Tools";
import UploadPopUp, { IUploadPopUpRef } from "./UploadPopUp";
import MyProjects from "./MyProjects";
import { useRouter } from "next/router";
import { openFileUploaderAtom } from "@/modules/marketplaceListing/Atoms";
import ErrorBoundary from 'src/modules/canvas/errorBoundry';
import StandardMarketplaces from "./StandardMarketplaces";
import AIBckgrounds from "./AIBackgrounds";

export default function newHomePage() {
    const {user, isAuthenticated} = useAuth();
    const popUpRef = useRef<IUploadPopUpRef>();
    const getSegmentPayloadAtom = useAtomValue(segmentEventPayload);
    const trackRef = useRef(false);
    const router = useRouter();
    const setOpenFileUploader = useSetAtom(openFileUploaderAtom);
    const setLoginPopupAtom = useSetAtom(showLoginPopupAtom);

    useEffect(() => { // remove the email query param if Authenticated and open Listing Popup if passed query param redirectListing.
        if (isAuthenticated) {
            if (router && router.query.redirectListing) {
                setOpenFileUploader(true);
            }
            const newQuery = {...router.query};
            delete newQuery?.email;
            delete newQuery?.redirectListing;
            router.replace({ pathname: router.pathname, query: newQuery });
        }
    }, [isAuthenticated]);

    useEffect(() => {
        if (user?.entity?.entity?._id && !trackRef.current) {
          trackRef.current = true;
          TrackWebappEvent(
            `${process.env.NEXT_PUBLIC_EVENT_TRACK_TYPE}${EventTrackName._load_studio_hp}`, {...getSegmentPayloadAtom});
        }
      }, [getSegmentPayloadAtom]); 

      // useEffect check for infographic user for Bulk AI Jobs to make them login
      useEffect(() => {
        // prefetch my Projects Page
        router.prefetch("/dashboard/my_projects?tab=COMPLETED");
        
        if (sessionStorage.getItem("nextPath"))
            setLoginPopupAtom(true);
      }, [])

    return <AuthGuard>
        <ErrorBoundary name={'Homepage'}>
        <ErrorBoundary name={'Header'}>
            <Header />
        </ErrorBoundary>
        <div css={emotionStyles.container}>
            <ErrorBoundary name={'MainSection'}>

                {user?.user?.login_type !== "Guest" &&
                    <div css={emotionStyles.projectsAndCustomPresetsContainer}>
                        <MyProjects />
                        <CustomMarketplaces popUpRef={popUpRef} userId={user?.user?._id} companyName={user?.entity.entity?.company_name} />
                    </div>
                }
                <MainSection>
                    <Jumbotron />
                    <Tools popUpRef={popUpRef} />
                    <AIBckgrounds popUpRef={popUpRef} />
                    <div css={emotionStyles.socialPresetsContainer}>
                        <StandardMarketplaces popUpRef={popUpRef} userId={user?.user?._id}/>
                        <SocialMedia popUpRef={popUpRef}/>
                    </div>
                    <FeaturedTemplates />
                </MainSection>
            </ErrorBoundary>

            <ErrorBoundary name={'Footer'}>
                <Footer />
            </ErrorBoundary>
        </div>
        </ErrorBoundary>
        <UploadPopUp ref={popUpRef} />
    </AuthGuard>;
}

const emotionStyles = {
    container: css`
        max-width:100vw;
        overflow-x: hidden;
        *::-webkit-scrollbar {
            display: none;
          };
        font-family: Objectivity-Bold;
    `,
    projectsAndCustomPresetsContainer: css `
    z-index:-1;
    `,
    rightBlur:css`
        width: 100px;
        height: 100%;
        background: #FFF;
        filter: blur(2px);
        bottom: 0px;
        right: 0px;
        position:absolute;
    `,
    socialPresetsContainer: css`
        display: flex;
        align-items: center;
        gap: 40px;
        margin-bottom: 35px;
    `
}